import * as React from 'react'
function SvgUsb(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 16h-8v8h2v2.6L22 29V10.8l2.6 2.6 2.8-2.8-6-6c-.8-.8-2-.8-2.8 0l-6 6 2.8 2.8 2.6-2.6V29l-6-2.4v-3.2c1.2-.6 2-2 2-3.4 0-2.2-1.8-4-4-4s-4 1.8-4 4c0 1.4.8 2.8 2 3.4V28c0 .8.4 1.6 1.2 1.8l8.8 3.6V36h4v-2.6l8.8-3.4c.8-.4 1.2-1 1.2-1.8v-4h2V16z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgUsb
